<div>
  <div
    *ngFor="let button of linksFormArray.controls; let i = index"
    [formGroup]="button"
    class="array-entry"
    [class.array-entry--outlined]="outlinedEntries"
    [class.array-entry--top-right-delete]="topRightDelete"
    [class.array-entry--roomy]="roomyFields"
  >
    <div class="array-entry-header">
      <h3>Button {{ i + 1 }}</h3>
      <button mat-icon-button class="array-entry__delete" (click)="removeButton(i)">
        <mat-icon>delete_forever</mat-icon>
      </button>
    </div>

    <ng-container *ngIf="stackedPrimaryFields; else defaultPrimaryFields">
      <mat-form-field appearance="outline" class="button-primary-field">
        <mat-label>Text</mat-label>
        <input matInput formControlName="buttonText" />
        <mat-hint>Text shown on the button.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="button-primary-field">
        <mat-label>Icon</mat-label>
        <input matInput formControlName="buttonIcon" />
        <mat-hint>Optional Material icon name.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="button-primary-field">
        <mat-label>Route Link</mat-label>
        <input matInput formControlName="routeLink" />
        <mat-hint>Route opened by this button.</mat-hint>
      </mat-form-field>

      <div class="button-style-row">
        <mat-form-field appearance="outline" class="button-style-row__size">
          <mat-label>Size</mat-label>
          <input matInput formControlName="buttonFontSize" type="number" />
        </mat-form-field>

        <ng-container *ngIf="compactColorPicker; else defaultButtonFontColor">
          <lib-color-picker-square
            [formGroup]="button"
            controlName="buttonFontColor"
            ariaLabel="Button text colour"
          ></lib-color-picker-square>
        </ng-container>

        <ng-template #defaultButtonFontColor>
          <mat-form-field appearance="outline" class="color-input">
            <mat-label>Text Colour</mat-label>
            <input type="color" matInput formControlName="buttonFontColor" />
          </mat-form-field>
        </ng-template>
      </div>
    </ng-container>

    <ng-template #defaultPrimaryFields>
      <lib-text-editor
        [formGroup]="button"
        textFormControlName="buttonText"
        fontSizeFormControlName="buttonFontSize"
        fontColorFormControlName="buttonFontColor"
        [compactColorPicker]="compactColorPicker"
        textHint="Text shown on the button."
      ></lib-text-editor>

      <mat-form-field appearance="outline" [class.button-secondary-field]="roomyFields">
        <mat-label>Icon</mat-label>
        <input matInput formControlName="buttonIcon" />
        <mat-hint>Optional Material icon name.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" [class.button-secondary-field]="roomyFields">
        <mat-label>Route Link</mat-label>
        <input matInput formControlName="routeLink" />
        <mat-hint>Route opened by this button.</mat-hint>
      </mat-form-field>
    </ng-template>

    <lib-color-picker-square
      *ngIf="compactColorPicker; else defaultButtonBackgroundColor"
      [formGroup]="button"
      controlName="buttonBackgroundColor"
      ariaLabel="Button background colour"
      label="Background Colour"
    ></lib-color-picker-square>

    <ng-template #defaultButtonBackgroundColor>
      <mat-form-field appearance="outline" class="color-input">
        <mat-label>Background Colour</mat-label>
        <input type="color" matInput formControlName="buttonBackgroundColor" />
      </mat-form-field>
    </ng-template>
  </div>

  <div style="text-align: center">
    <button mat-flat-button color="primary" (click)="addButton()">Add Link Button</button>
  </div>
</div>
